import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Base from './Base';

function Pages() {
  return (
    <Base>
      <div className="dark:bg-dark min-h-screen transition-colors duration-200">
        <Helmet><title>Pages | Aman Medical Complex Gilgit</title></Helmet>

        {/* Page Title Section */}
        <section className="relative py-32 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://images.unsplash.com/photo-1512678080530-7760d81faba6?auto=format&fit=crop&q=80&w=1600"
              alt="Pages Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#002147]/80 dark:bg-gray-900/90"></div>
          </div>
          <div className="container mx-auto px-4 text-center relative z-10">
            <h1 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">Available Pages</h1>
            <div className="flex items-center justify-center gap-2 text-[#007bff] font-bold uppercase tracking-[0.2em] text-sm">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              <span>/</span>
              <span className="text-white/60">Pages</span>
            </div>
          </div>
        </section>

        <section className="py-24 container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Available Pages</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <a href="/about" className="bg-white dark:bg-gray-700 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <h3 className="text-xl font-bold dark:text-white mb-2">About Us</h3>
                <p className="text-gray-600 dark:text-gray-400">Learn more about our hospital</p>
              </a>
              <a href="/services" className="bg-white dark:bg-gray-700 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <h3 className="text-xl font-bold dark:text-white mb-2">Services</h3>
                <p className="text-gray-600 dark:text-gray-400">Our medical services</p>
              </a>
              <a href="/appointment" className="bg-white dark:bg-gray-700 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <h3 className="text-xl font-bold dark:text-white mb-2">Appointment</h3>
                <p className="text-gray-600 dark:text-gray-400">Book your appointment</p>
              </a>
              <a href="/contact" className="bg-white dark:bg-gray-700 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <h3 className="text-xl font-bold dark:text-white mb-2">Contact</h3>
                <p className="text-gray-600 dark:text-gray-400">Get in touch with us</p>
              </a>
            </div>
          </div>
        </section>
      </div>
    </Base>
  );
}

export default Pages;

